export default "__VITE_PUBLIC_ASSET__215a8c7c__"